/* Slideshow > Swiper Initialize
	=============================================================== */

// Select DOM
var lctSlideshow = document.querySelector('.lct-slideshow-container');
// if exist
if (lctSlideshow) {
  var lctSlideshowSwiper = new Swiper('.lct-slideshow-container', {
    slidesPerView: 1,
    /*freeMode: true,*/
    lazy: true,
    pagination: {
      el: '.lct-slideshow .swiper-pagination',
    },
    autoHeight: true,
    navigation: {
      //  nextEl: ".lct-slideshow .swiper-button-next",
      //  prevEl: ".lct-slideshow .swiper-button-prev",
    },
  });
}

/* A la Une > Swiper Initialize
	=============================================================== */

var aLaUneSwiper = new Swiper('.section-list.a-la-une', {
  slidesPerView: 2.2,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-1',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-1',
    prevEl: '.swiper-button-prev-1',
  },
});

/* Nouveautés > Swiper Initialize
=============================================================== */
const nouveautesSwiper = new Swiper('.section-list.nouveautes', {
  slidesPerView: 2.2,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-3',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-3',
    prevEl: '.swiper-button-prev-3',
  },
});

/* Meilleures ventes > Swiper Initialize
	=============================================================== */

var meilleuresVentesSwiper = new Swiper('.section-list.meilleures-ventes', {
  slidesPerView: 2.2,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-4',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-4',
    prevEl: '.swiper-button-prev-4',
  },
});

/* Promotions > Swiper Initialize
	=============================================================== */

var promotionsSwiper = new Swiper('.section-list.promotions', {
  slidesPerView: 2.2,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  breakpoints: {
    640: {
      slidesPerView: 3.5,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 4.5,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-5',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-5',
    prevEl: '.swiper-button-prev-5',
  },
});

/* Marques > Swiper Initialize
	=============================================================== */

var marquesSwiper = new Swiper('.section-list.marques', {
  slidesPerView: 2.2,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 5.2,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 6.5,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 7.2,
      spaceBetween: 20,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-2',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-2',
    prevEl: '.swiper-button-prev-2',
  },
});

/* Avis > Swiper Initialize
	=============================================================== */

var avisSwiper = new Swiper('.section-list.avis', {
  slidesPerView: 1.1,
  spaceBetween: 16,
  freeMode: true,
  lazy: true,
  loop: true,
  breakpoints: {
    640: {
      slidesPerView: 2.2,
      spaceBetween: 20,
      freeMode: false,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 25,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
  scrollbar: {
    el: '.swiper-scrollbar-6',
    draggable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next-6',
    prevEl: '.swiper-button-prev-6',
  },
});
